import AttachIcon from '../icons/attach_1.svg';
import MentionIcon from '../icons/mention.svg';
import SendIcon from '../send_mui_icon.svg';
import PlusIcon from '../plus_icon.svg';

const tui_editor = (theme) => {
	return {
		'.tui-toolbar-button-attach': {
			backgroundImage: `url(${AttachIcon})`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			background: 'transparent',
			backgroundSize: '23px 32px',
		},
		// '.tui-toolbar-button-send': {
		// 	backgroundImage: `url(${SendIcon}) !important`,
		// 	backgroundRepeat: 'no-repeat !important',
		// 	backgroundPosition: 'center !important',
		// 	backgroundColor: theme.palette.primary.main,
		// 	borderRadius: '50% !important',
		// },
		'.tui-toolbar-button-send': {
			background: 'none',
			border: 'none !important',
			color: theme.palette.primary.main + ' !important',
		},
		'.tui-toolbar-button-send:hover': {
			// backgroundColor: theme.palette.secondary.main + ' !important',
			color: theme.palette.secondary.main + ' !important',
		},
		'.tui-toolbar-button-mention': {
			backgroundImage: `url(${MentionIcon})`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundSize: '22px 22px',
      background: 'transparent',
		},
		'.tui-toolbar-button-plus-menu': {
			backgroundImage: `url(${PlusIcon})`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: theme.palette.primary.main,
			backgroundSize: '23px 32px',
			border: 'none !important',
			borderRadius: '50% !important',
		},
		'.tui-toolbar-button-disabled': {
			// backgroundColor: theme.palette.grey[300] + ' !important',
			color: theme.palette.action.disabled + ' !important',
			cursor: 'not-allowed !important',
			pointerEvents: 'none !important',
		},
	};
};

export default tui_editor;
